<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <div  (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="video-left-pane flex-16">
        <app-videos-left-navigation-pane></app-videos-left-navigation-pane>
      </div>
      <div class="flex-80">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!-- Only iPadPro and Medium size Desktop HTML5 Goes here... -->
<div *ngIf='screenWidth > 767 && screenWidth < 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="video-left-pane md flex-18">
        <app-videos-left-navigation-pane></app-videos-left-navigation-pane>
      </div>
      <div class="flex">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!--  Only Tablet or iPad HTML5 Goes here... -->
<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="video-sm-left-pane">
      <app-videos-left-navigation-pane></app-videos-left-navigation-pane>
    </div>
    <div class="video-sm-content-pane">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- Only Mobile hTML5 goes here... -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div  (window:orientationchange)="screenRotate($event)">
    <div class="video-xs-left-pane">
      <app-videos-left-navigation-pane></app-videos-left-navigation-pane>
    </div>
    <div class="video-xs-content-pane">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>